import { lerpColor } from '../../color';
import { hsl, type World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const H = 235;
const S = 42;
const A1 = 52;
const A2 = 325;

const L = hsl(H, 72, 82);
const HELD = hsl(A1, 88, 78);
const SPOT = hsl(A2, 85, 76);
const RIM = hsl(H, 45, 92);

const world: World = {
  id: 'bloco',
  name: 'Bloco',
  seed: 'bloco',
  legacy: false,
  hue: H,
  ceil: 0x2f3360,
  font: 'Lilita One',
  fontFile: 'lilita-one-400.woff2',
  fontWeight: '400',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.4,
  fillAlpha: 0.7,
  palette: {
    bg: hsl(H, S, 10),
    ink: hsl(H, S + 12, 5),
    rim: RIM,
    held: HELD,
    heldShade: hsl(A1, 60, 60),
    heldLight: hsl(A1, 90, 90),
    incoming: {
      circle: L,
      square: SPOT,
      triangle: lerpColor(L, HELD, 0.5),
      hex: lerpColor(L, SPOT, 0.5),
    },
    spot: SPOT,
    path: hsl(H, 30, 72),
    text: hsl(H, 40, 94),
    sparks: [HELD, SPOT, L, RIM],
  },
  burst: { count: 12, speed: 0.6, drag: 3, gravity: 0.4, spin: 6, life: 1, sizeMin: 0.009, sizeMax: 0.02 },
  dress,
  fx,
  paint,
};

export default world;
